module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "logo",
    attrs: {
      "viewBox": _vm.viewport,
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    staticClass: "logo-icon logo-element",
    class: {
      animating: _vm.isLoading
    },
    style: (_vm.iconStyle)
  }, [_c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#123C4C' : '#123C4C',
      "points": "45.9 53 56.1 56 61.2 61.8 45.9 70.6 30.6 61.8 36.6 56.1"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#12466D' : '#12466D',
      "points": "30.6 44.1 45.9 53 38.2 57.4 30.6 61.8 15.3 53 22.6 46.3"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#12466D' : '#12466D',
      "points": "61.2 44.1 69.1 46.5 76.5 53 61.2 61.8 53.5 57.4 45.9 53"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#165D91' : '#165D91',
      "points": "61.2 44.1 61.2 26.5 69.3 29.3 76.5 35.3 76.5 53"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#165D91' : '#165D91',
      "points": "30.6 44.1 30.6 26.5 22.7 29 15.3 35.3 15.3 53"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": "#000000",
      "fill-rule": "nonzero",
      "fill-opacity": "0.1",
      "points": "30.6 26.5 22.7 29 15.3 35.3 30.6 29.3"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": "#000000",
      "fill-rule": "nonzero",
      "fill-opacity": "0.1",
      "points": "61.2 26.5 69.1 29 76.5 35.3 61.2 29.3"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#66B6F2' : '#1A6BA8',
      "points": "76.5 17.7 91.7 26.5 76.5 35.3 61.2 26.5 67.8 21.1"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#66B6F2' : '#1A6BA8',
      "points": "15.3 17.7 0 26.5 15.3 35.3 30.6 26.5 25.2 20.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#AFD8F2' : '#1E88D8',
      "points": "61.2 8.8 76.5 17.7 61.2 26.5 45.9 17.7 52.4 12.1"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#AFD8F2' : '#1E88D8',
      "points": "30.6 8.8 15.3 17.7 30.6 26.5 45.9 17.7 40.2 12.4"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#FFFFFF' : '#1B90F5',
      "points": "45.9 0 45.9 0 45.9 0 61.2 8.8 45.9 17.7 30.6 8.8"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "logo-element",
    style: (_vm.textStyle),
    attrs: {
      "fill-rule": "nonzero"
    }
  }, [_c('path', {
    attrs: {
      "fill": _vm.isLight ? '#FFFFFF' : '#1B90F5',
      "d": "M27.9,9.5 L21.1,29.6 L14.4,9.5 L0.5,9.5 L14.4,45.3 L14.1,46 C13.7,46.9 12.1,47.4 9.5,47.4 C8.6,47.4 7.5,47.2 6.7,46.7 L4.9,58.4 C6.1,58.8 9.1,59 10,59 C17.4,58.8 23.3,57.2 26.4,49.1 L41.7,9.5 L27.9,9.5 L27.9,9.5 Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": _vm.isLight ? '#FFFFFF' : '#1B90F5',
      "d": "M58,8.6 C45.5,8.6 38.2,17.2 38.2,27.1 C38.2,37 45.5,45.6 58,45.6 C70.6,45.6 77.9,36.9 77.9,27.1 C77.8,17.2 70.5,8.6 58,8.6 Z M58,34 C54,34 51.7,31 51.7,27.1 C51.7,23.2 54,20.2 58,20.2 C62.1,20.2 64.4,23.2 64.4,27.1 C64.3,31 62.1,34 58,34 Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": _vm.isLight ? '#FFFFFF' : '#1B90F5',
      "d": "M103.8,31.2 C102.7,32.4 101.2,34 98.3,34 C95.1,34 93.2,32.6 93.2,29 L93.2,9.5 L80,9.5 L80,34.7 C80,40.8 83.5,45.6 91.7,45.6 C97.9,45.6 101.8,43 103.8,40.8 L103.8,44.7 L117,44.7 L117,9.5 L103.9,9.5 L103.9,31.2 L103.8,31.2 Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": _vm.isLight ? '#FFFFFF' : '#1B90F5',
      "d": "M132.7,13.3 L132.7,9.4 L119.6,9.4 L119.6,44.7 L132.7,44.7 L132.7,24.9 C135.3,21 138.2,21 143.5,20.9 L143.5,9.5 C139.5,9.5 134.9,10.8 132.7,13.3 Z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "Shape",
      "fill": "#123C4C",
      "points": "176.5 18.8 176.5 9.6 146.1 9.6 146.1 21 158.5 21 146.1 35.2 146.1 44.8 176.8 44.8 176.8 33.4 163.8 33.4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-path",
      "fill": "#123C4C",
      "x": "179.2",
      "y": "9.6",
      "width": "13.1",
      "height": "35.3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M216.7,34.1 C214.9,34.1 213.8,32.6 213.8,30.8 L213.8,21 L221,21 L221,9.6 L213.8,9.6 L213.8,0 L200.7,0 L200.7,9.6 L194.9,9.6 L194.9,21 L200.7,21 L200.7,34.7 C200.7,42.1 205,45.8 212.8,45.8 C217.3,45.8 220.3,44.7 221.7,43.5 L219.4,33.6 C219,33.7 217.9,34.1 216.7,34.1 Z",
      "fill": "#123C4C"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M259.7,28.3 C259.7,15.9 251.7,8.5 241.4,8.5 C230,8.5 222.2,16.7 222.2,27 C222.2,35.2 226.5,41.1 232.9,43.8 L245.8,36.4 C239.1,35.7 236.5,33.4 235.8,31.1 L254.9,31.1 L259.7,28.3 Z M235.6,22.8 C236,21.2 237.4,18.6 241.4,18.6 C245.6,18.6 246.9,21.3 247.2,22.8 L235.6,22.8 Z",
      "fill": "#123C4C"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M260.7,28.5 C260.7,16.1 252.7,8.7 242.4,8.7 C231,8.7 223.2,16.9 223.2,27.2 C223.2,35.4 227.5,41.3 233.9,44 L246.8,36.6 C240.1,35.9 237.5,33.6 236.8,31.3 L255.9,31.3 L260.7,28.5 Z M236.6,22.9 C237,21.3 238.4,18.7 242.4,18.7 C246.6,18.7 247.9,21.4 248.2,22.9 L236.6,22.9 Z",
      "fill": "#123C4C"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-895c6782","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Logo.vue
// module id = 544
// module chunks = 2